import { useState } from "react";
import { CampoNumero, Resultado, Dato, Rejilla, mxn } from "../components/campos.jsx";
import { presupuesto503020 } from "../lib/calc.js";

const NECESIDADES = [
  ["vivienda", "Vivienda (renta / hipoteca)"],
  ["alimentacion", "Alimentación (súper / despensa)"],
  ["servicios", "Servicios (luz, agua, gas, internet)"],
  ["transporte", "Transporte (gasolina / pasajes)"],
  ["salud", "Salud y seguros"],
];

const DESEOS = [
  ["ocio", "Ocio, restaurantes y salidas"],
  ["suscripciones", "Suscripciones y streaming"],
  ["compras", "Compras personales"],
];

export default function Presupuesto() {
  const [ingreso, setIngreso] = useState(25000);
  const [extra, setExtra] = useState(0);
  const [necesidades, setNecesidades] = useState({ vivienda: 7000, alimentacion: 4000, servicios: 1500, transporte: 1500, salud: 800 });
  const [deseos, setDeseos] = useState({ ocio: 2000, suscripciones: 500, compras: 1500 });
  const [ahorro, setAhorro] = useState(3000);

  const total = ingreso + extra;
  const sumaNec = Object.values(necesidades).reduce((a, b) => a + b, 0);
  const sumaDes = Object.values(deseos).reduce((a, b) => a + b, 0);

  const r = presupuesto503020(total, { necesidades: sumaNec, deseos: sumaDes, ahorro });

  return (
    <div className="space-y-6">
      <Rejilla cols="lg:grid-cols-2">
        <div className="space-y-4">
          <CampoNumero label="Sueldo / ingreso fijo" valor={ingreso} onChange={setIngreso} prefijo="$" min={0} />
          <CampoNumero label="Ingresos extra / secundarios" valor={extra} onChange={setExtra} prefijo="$" min={0} />

          <div className="tarjeta space-y-3">
            <h3 className="text-2xs font-bold uppercase tracking-wider texto-3">
              Necesidades — objetivo 50%
            </h3>
            {NECESIDADES.map(([k, label]) => (
              <CampoNumero
                key={k}
                label={label}
                valor={necesidades[k]}
                onChange={(v) => setNecesidades({ ...necesidades, [k]: v })}
                prefijo="$"
                min={0}
              />
            ))}
          </div>

          <div className="tarjeta space-y-3">
            <h3 className="text-2xs font-bold uppercase tracking-wider texto-3">
              Deseos — objetivo 30%
            </h3>
            {DESEOS.map(([k, label]) => (
              <CampoNumero
                key={k}
                label={label}
                valor={deseos[k]}
                onChange={(v) => setDeseos({ ...deseos, [k]: v })}
                prefijo="$"
                min={0}
              />
            ))}
          </div>

          <CampoNumero label="Ahorro / inversión — objetivo 20%" valor={ahorro} onChange={setAhorro} prefijo="$" min={0} />
        </div>

        <div className="space-y-3">
          <Resultado
            label={r.sobrante >= 0 ? "Te sobra al mes" : "Te falta al mes"}
            valor={mxn(Math.abs(r.sobrante))}
            tono={r.sobrante >= 0 ? "positivo" : "alerta"}
            nota={r.sobrante >= 0 ? "Puedes destinarlo a ahorro" : "Tus gastos superan tu ingreso"}
          />

          <div className="tarjeta space-y-4">
            <Barra label="Necesidades" real={r.porcentajes.necesidades} objetivo={50} monto={sumaNec} sugerido={r.sugerido.necesidades} />
            <Barra label="Deseos" real={r.porcentajes.deseos} objetivo={30} monto={sumaDes} sugerido={r.sugerido.deseos} />
            <Barra label="Ahorro" real={r.porcentajes.ahorro} objetivo={20} monto={ahorro} sugerido={r.sugerido.ahorro} invertir />
          </div>

          <div className="tarjeta">
            <Dato label="Ingreso total" valor={mxn(total)} />
            <Dato label="Gastos totales" valor={mxn(sumaNec + sumaDes)} />
            <Dato label="Ahorro" valor={mxn(ahorro)} />
            <Dato label="Diferencia" valor={mxn(r.sobrante)} destacar />
          </div>
        </div>
      </Rejilla>
    </div>
  );
}

function Barra({ label, real, objetivo, monto, sugerido, invertir = false }) {
  // En gastos, pasarse es malo; en ahorro, pasarse es bueno.
  const bien = invertir ? real >= objetivo : real <= objetivo;
  const ancho = Math.min(100, real);

  return (
    <div>
      <div className="mb-1 flex items-baseline justify-between text-sm">
        <span className="texto-2">
          {label} <span className="text-2xs texto-3">· objetivo {objetivo}%</span>
        </span>
        <span className={`font-mono text-sm font-bold ${bien ? "text-[color:var(--positivo)]" : "text-[color:var(--aviso)]"}`}>
          {real.toFixed(1)}%
        </span>
      </div>
      <div className="h-2 overflow-hidden rounded-full superficie-2">
        <div
          className={`h-full rounded-full transition-all ${bien ? "bg-[color:var(--positivo-bg)]" : "bg-[color:var(--aviso-bg)]"}`}
          style={{ width: `${ancho}%` }}
        />
      </div>
      <div className="mt-1 flex justify-between text-2xs texto-3">
        <span>Tú: {mxn(monto, 0)}</span>
        <span>Sugerido: {mxn(sugerido, 0)}</span>
      </div>
    </div>
  );
}
